import script from "./UserRankingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRankingPage.vue?vue&type=script&setup=true&lang=js"

import "./UserRankingPage.vue?vue&type=style&index=0&id=6aeb898c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aeb898c"]])

export default __exports__